<template>
  <div class="Liveing">
    <LiveHeader :title='livetitle' :status='livestatus' :errorStatus='localLiveInfo.status'></LiveHeader>
    <el-tabs  @tab-click="tabClick" v-model="tabname">
      <el-tab-pane
        :label="item.columnname"
        :name="item.innerid"
        v-for="item in tabList"
        :key="item.columnname"
      >
      <!-- 图文直播 -->
        <div class="imageText imageTextliveing" v-if="item.columntype==1">
          <div class="ueditor ml10">
            <el-form :model="imagetextform" label-position="right" ref="imagetextform" id="imagetextform">
              <el-form-item label="发言人" prop="spokesman">
                  <!-- <el-input
                    v-model="imagetextform.spokesman"
                    autocomplete="off"
                    name="spokesman"
                    placeholder="请填写发言人（非必填）"
                    style="width:200px;"
                    clearable
                  ></el-input> -->


                  <el-select v-model="imagetextform.spokesman" filterable collapse-tags allow-create default-first-option placeholder="输入发言人（仅一个）" size="small">
                    <el-option
                      v-for="item in dguserList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>

                  

                  <el-input class="ml10 mr10"
                    v-model="imagetextform.spokesmancolor"
                    autocomplete="off"
                    name="spokesmancolor"
                    placeholder=""
                    style="width:100px"
                  ></el-input>
                  <!-- <el-button type="primary" @click="addmakeNewImageText" size="small">添加发言人</el-button> -->
                  <!-- <div class="text-color-wrap">
                    <span class="text-color">{{imagetextform.spokesmancolor}}</span>
                   <el-color-picker v-model="imagetextform.spokesmancolor"></el-color-picker>
                  </div> -->
                </el-form-item>
              <VueUeditorWrap :config="config" v-model="msg" ref="tuwen"></VueUeditorWrap>
            </el-form>
            <div class="release-icon">
              <el-button type="primary" @click="release(1)" v-if="localLiveInfo.status !== 30">提  交</el-button>
            </div>
          </div>
          <div class="image-list">
            <div class="image-item" v-for="item in imageList" :key="item.innerid">
              <div class="top-set-span">
                <span class="time-icon">{{item.datetime}}</span>
                <span class="edit-icon" @click="editImageText(item.innerid)">
                  <label></label>编辑
                </span>
                <span class="del-icon" @click="delClick(item.innerid)">
                  <label></label>删除
                </span>
              </div>
              <div v-html="item.content"></div>
            </div>
          </div>
        </div>
        <!-- 海报 -->
        <div v-else-if="item.columntype==2" class="post-wrap postwrap">
          <div class="poster-form">

            <el-radio-group v-model="postActive" fill="#A3D0FD" text-color="#1989FA" style="margin: 10px 0 12px 12px; background: #E6F1FC">
              <el-radio-button label="first">自动生成</el-radio-button>
              <el-radio-button label="second">手动上传</el-radio-button>
            </el-radio-group>


             <el-tabs v-model="postActive">
              <el-tab-pane name="first">
                <el-form :model="form" :rules="rules" label-position="right" ref="form" id="form">
                  <el-row class="edit-hb-row-mb">
                    <el-col :span="24">
                      <el-form-item label="海报标题" prop="title">
                        <el-input
                          v-model="form.title"
                          autocomplete="off"
                          name="title"
                          placeholder="请输入您的海报标题，不超过20字。"
                          clearable
                        ></el-input>
                        <!-- <div class="text-color-wrap">
                          <span class="text-color">{{titlecolor}}</span>
                          <el-color-picker v-model="titlecolor"></el-color-picker>
                        </div> -->
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="edit-hb-row-mb">
                    <el-col :span="12">
                      <el-form-item label="嘉宾姓名" prop="name">
                          <el-input class="inp-two-first" v-model="form.name" autocomplete="off" name="name" placeholder="请输入嘉宾姓名" clearable></el-input>
                          <!-- <div class="text-color-wrap">
                            <span class="text-color">{{namecolor}}</span>
                            <el-color-picker v-model="namecolor"></el-color-picker>
                          </div> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="嘉宾公司 " prop="company">
                        <el-input
                          v-model="form.company"
                          autocomplete="off"
                          name="company"
                          placeholder="请输入嘉宾公司" 
                          clearable
                        ></el-input>
                        <!-- <div class="text-color-wrap">
                          <span class="text-color">{{companycolor}}</span>
                          <el-color-picker v-model="companycolor"></el-color-picker>
                        </div> -->
                      </el-form-item>
                    </el-col>
                  </el-row>          
                  <el-row class="edit-hb-row-mb">
                    <el-col :span="24">
                      <el-form-item label="嘉宾语录" prop="text">
                        <el-input
                          v-model="form.text"
                          autocomplete="off"
                          name="text"
                          rows="2"
                          type="textarea"
                          placeholder="请输入嘉宾语录，不超过50字"
                          clearable
                        ></el-input>
                        <!-- <div class="text-color-wrap">
                          <span class="text-color">{{textcolor}}</span>
                          <el-color-picker v-model="textcolor"></el-color-picker>
                        </div> -->
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="edit-hb-row-mb">
                    <el-col :span="12">
                      <el-form-item label="主办单位">
                        <el-input class="inp-two-first" v-model="form.unit" autocomplete="off" name="unit" placeholder="请输入主办单位" clearable></el-input>
                        <!-- <div class="text-color-wrap">
                          <span class="text-color">{{unitcolor}}</span>
                          <el-color-picker v-model="unitcolor"></el-color-picker>
                        </div> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="时间地点">
                        <el-input v-model="form.time" autocomplete="off" name="time" placeholder="请输入时间地点" clearable></el-input>
                        <!-- <div class="text-color-wrap">
                          <span class="text-color">{{timecolor}}</span>
                          <el-color-picker v-model="timecolor"></el-color-picker>
                        </div> -->
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="edit-hb-row-mb">
                    <el-col :span="24">
                      <el-form-item label="嘉宾照片" prop='cover'>
                        <div class="cover-setting">
                          <div class="up-load">
                            <!-- <el-button size="small" type="primary">上传</el-button> -->
                            <input
                              type="file"
                              class="uploadBtn"
                              id="guestfile"
                              name="guestfile"
                              ref="guestfile"
                              @change="previewImage('coverpic','guestfile')"
                            >
                            <div class="image">
                              <img src="cover" alt id="coverpic" ref='coverurl'>
                            </div>
                            <div slot="tip" class="el-upload__tip">
                                <div>建议上传尺寸 <span class="col-red">{{photoSize}}</span></div>
                                <div>支持PNG、JPG、JPEG格式，不超过2M！</div>  
                            </div>
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>        
                  <el-row class="edit-hb-row-mb">
                    <el-col :span="24">      
                      <el-form-item label="二维码">
                        <div class="cover-setting qrcode">
                          <div class="up-load">
                            <input
                              type="file"
                              class="uploadBtn qrcodeinput"
                              id="logofile"
                              name="logofile"
                              ref="logofile"
                              @change="previewImage('logopic','logofile')"
                            >
                            <div class="image">
                              <img src="" alt id="logopic" ref='logopic'>
                            </div>
                            <!-- <el-button size="small" type="primary">上传</el-button> -->
                            <div slot="tip" class="el-upload__tip">
                              <div>建议上传尺寸300*300</div>
                              <div>支持PNG、JPG、JPEG格式，不超过500K！</div>
                            </div>
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>     
                  <el-row class="edit-hb-row-mb">
                    <el-col :span="24">       
                      <el-form-item label="模板选择" prop='template'>
                        <div class="aa">
                          <div class="image-template">
                            <img
                              :src="item.logoatturl"
                              alt
                              id="posterpic"
                              :class="{active:item.innerid==templateid}"
                              v-for="item in templateList"
                              :key="item.innerid"
                              @click="templateClick(item)"
                            >
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>     
                </el-form>
                <div class="footer-btn">
                  <el-button @click="save(1)" :loading="isLoadingSave">预览海报</el-button>
                  <el-button type="primary"  @click="save(0)" :loading="isLoadingSavePoster">上传海报</el-button>
                </div>
              </el-tab-pane>
              <el-tab-pane name="second">
                <el-form id="formByhand" :rules="formByhandRules" ref="formByhand">
                  <el-form-item label="嘉宾照片" prop='coverByHand'>
                    <div class="cover-setting">
                      <div class="up-load">
                        <!-- <el-button size="small" type="primary">上传</el-button> -->
                        <input
                          type="file"
                          class="uploadBtn"
                          id="guestHandfile"
                          name="guestHandfile"
                          ref="guestHandfile"
                          @change="previewImage('coverHandpic','guestHandfile')">

                        <div class="image">
                          <img :src="coverByHand" alt id="coverHandpic" ref='coverByHand'>
                        </div>
                        <div slot="tip" class="el-upload__tip">
                            <div class="col-red">建议上传尺寸938*1672</div>
                            <div>支持PNG、JPG、JPEG格式，不超过2M！</div>  
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-form>
                <div class="footer-btn">
                  <el-button type="primary" @click="saveByHand('formByhand')" :loading="isLoadingSavePoster">上传海报</el-button>
                </div>
              </el-tab-pane>
            </el-tabs>

          </div>
          <div class="poster-list">
            <span v-for="(item,index) in posterlist" :key="item.innerid">
              <img :src="item.posterurl" alt>
              <label class="copytext" for @click="copyPostText(item.innerid,index)">复制文字</label>
              <label class="delposter" for @click="delPostClick(item.innerid,index)">删除海报</label>
            </span>
          </div>
        </div>
        <!-- 活动详情 -->
        <div v-else-if="item.columntype==3" class="imageText detailsactive">
            <div class="activity-detail ueditor">
            <VueUeditorWrap :config="config3" v-model="detailMsg"></VueUeditorWrap>
            <div class="release-icon">
              <el-button type="primary" @click="release(3)">提  交</el-button>
            </div>
          </div>
          <div class="image-list">
            <div class="image-item">
              <div v-html="detailMsg"></div>
            </div>
          </div>
        </div>
        <div v-else-if="item.columntype==11">
        
        </div>
      </el-tab-pane>
    </el-tabs>
    <Mdialog
      :dialogVisible="delPosterStatus"
      :dialogParams="dialogParams"
      @dialogSuccess="delPosterSuccess"
      @dialogCancle="delPosterStatus=false"
      title="确认删除该海报吗？"
      subtitle
    ></Mdialog>
    <Mdialog
      :dialogVisible="delImageStatus"
      :dialogParams="dialogImageParams"
      @dialogSuccess="delImageSuccess"
      @dialogCancle="delImageStatus=false"
      title="确认删除吗？"
      subtitle
    ></Mdialog>
    <!-- 预览弹窗 -->
    <el-dialog
      :visible.sync="dialogPreviewVisible"
      :before-close="previewClick"
      width="446px"
      title="海报预览"
      custom-class="preview-dialog"
    >
      <div>
        <img :src="previewImageurl" alt width="225" height="400">
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogPreviewVisible=false">取 消</el-button> -->
        <el-button type="primary" @click="dialogPreviewVisible=false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
// import MHeader from "@/pc/components/header/header.vue";
import Mdialog from "../components/dialog/dialog.vue";
import LiveHeader from "../components/live-header/live-header.vue";
import {getQueryParams} from '@/common/js/units'
const _url=window.location.origin;
// const _url = "http://q2850978q4.qicp.vip:22630/"
import { getPosterList, delPoster,getPosterTeml,doSavePoster,getDecorateList,delPicturetextLive,getPicturetextList,saveImagetextinfo,getLiveInfo,doSavePosterByHand} from "@/api/home";
import { mapActions } from 'vuex';
export default {
  components: { LiveHeader,VueUeditorWrap,Mdialog},
  data() {
    return {
      dialogPreviewVisible: false,
      isLoadingSave:false,
      isLoadingSavePoster:false,
      delPosterStatus: false,
      delImageStatus: false,
      is_preview: true,
      posterLoading:false,
      loadingMore:true,
      tabname:'',
      postActive:'first',
      dialogParams: "",
      dialogImageParams: "",
      msg: "",     //图文编辑内容
      detailMsg:'',  //活动详情内容               
      titlecolor: "", 
      namecolor: "",
      companycolor: "",
      textcolor: "",
      unitcolor: "",
      timecolor: "",
      previewImageurl: "",
      tabname: "",
      liveinnerid: "",
      livetitle:'',
      livestatus:'',
      url: "",
      imagetextform:{
        innerid:"",
        spokesman:"",
        spokesmancolor:"#1890ff"
      },
      dguserList:[],//主持人列表
      form: {
        title: "",
        name: "",
        company: "",
        text: "",
        unit: "",
        time: "",
        cover:'',
        template:''
      },
      coverByHand:'',
      config: {//默认图文直播
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 650,
          // 初始容器宽度 
          initialFrameWidth: 600,
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          serverUrl: `${_url}/api/admin/kmc/live/imagetext/uploadLiveContentImage?columntype=1`,
          configUrl: `${_url}/api/admin/kmc/live/imagetext/getUEditorConfig`,
          UEDITOR_HOME_URL: "/UEditor/",
          toolbars: [[
            'source', // 源代码
            '|',
            'undo', // 前进
            'redo', // 后退
            '|',
            'fontfamily', // 字体
            'fontsize', // 大小
            'bold', // 加粗
            'forecolor', // 字体颜色
            'italic', // 斜体
            'underline', // 下划线
            '|',
            'justifyleft', // 左对齐
            'justifycenter', // 居中
            'justifyright', // 右对齐
            'lineheight', // 行间距
            '|',
            'insertunorderedlist', // 无序列表
            'directionalityltr', // 从左向右输入
            'directionalityrtl', // 从右向左输入
            '|',
            'simpleupload', // 图片
            'link' // 链接
            ]
          ]
          // toolbars: [
          //   [
          //     "source",
          //     "selectall",
          //     "|",
          //     "undo",
          //     "redo",
          //     "searchreplace",
          //     "|",
          //     "bold",
          //     "underline",
          //     "strikethrough",
          //     "forecolor",
          //     "backcolor",
          //     "|",
          //     "removeformat",
          //     "formatmatch",
          //     "pasteplain",
          //     "|",
          //     "insertunorderedlist",
          //     "insertorderedlist",
          //     "unlink",
          //     "link",
          //     "|",
          //     "wechatedit",
          //   ],
          //   [
          //     // "fontfamily",
          //     // "fontsize",
          //     "justifyleft",
          //     "justifycenter",
          //     "justifyright",
          //     "justifyjustify",
          //     "imagenone",
          //     "imageleft",
          //     "imagecenter",
          //     "imageright",
          //     "|",
          //     "simpleupload",
          //     // "insertvideo",
          //     // "map",
          //     "horizontal",
          //     "|",
          //     "help"
          //   ]
          // ]
      },
      config3: {//图文信息
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 650,
          // 初始容器宽度
          initialFrameWidth: 600,
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          serverUrl: `${_url}/api/admin/kmc/live/imagetext/uploadLiveContentImage?columntype=3`,
          configUrl: `${_url}/api/admin/kmc/live/imagetext/getUEditorConfig`,
          UEDITOR_HOME_URL: "/UEditor/",
          toolbars: [[
            'source', // 源代码
            '|',
            'undo', // 前进
            'redo', // 后退
            '|',
            'fontfamily', // 字体
            'fontsize', // 大小
            'bold', // 加粗
            'forecolor', // 字体颜色
            'italic', // 斜体
            'underline', // 下划线
            '|',
            'justifyleft', // 左对齐
            'justifycenter', // 居中
            'justifyright', // 右对齐
            'lineheight', // 行间距
            '|',
            'insertunorderedlist', // 无序列表
            'directionalityltr', // 从左向右输入
            'directionalityrtl', // 从右向左输入
            '|',
            'simpleupload', // 图片
            'link' // 链接
            ]
          ]
      },
      coverurl: "",
      logourl: "",
      template: "",
      columninnerid: "",
      templateid: "",
      hostposteratturl:'',
      photoSize:'940*940',
      currentpage: 1,
      pagesize: 100,
      rules: {
        title: [
          // { required: true, message: "请输入直播标题", trigger: "blur" },
          { required: true, message: " ", trigger: "blur" },
          { min: 1, max: 50, message: '长度最多为50个字符', trigger: 'blur' }
        ],
        name: [
          // { required: true, message: "请输入嘉宾姓名", trigger: "blur" }
          { required: true, message: " ", trigger: "blur" }
        ],
        company: [
          // { required: true, message: "请输入嘉宾公司", trigger: "blur" }
          { required: true, message: " ", trigger: "blur" }
        ],
        text: [
          // { required: true, message: "请输入嘉宾语录", trigger: "blur" },
          { required: true, message: " ", trigger: "blur" },
          { min: 1, max: 50, message: '长度最多为50个字符', trigger: 'blur' }
         ],
        unit: [
          // { required: true, message: "请输入主办单位", trigger: "blur" }
          { required: true, message: " ", trigger: "blur" }
        ],
        time: [
          // { required: true, message: "请输入时间地点", trigger: "blur" }
          { required: true, message: " ", trigger: "blur" }
        ],
        cover: [
          // { required: true, message: "请选择一张嘉宾照片", trigger: "blur" }
          { required: true, message: " ", trigger: "blur" }
        ],
        template:[
          // { required: true, message: "请选择一张模板", trigger: "blur" }
          { required: true, message: " ", trigger: "blur" }
        ]        
      },
      formByhandRules:{
        coverByHand: [
          // { required: true, message: "请选择一张嘉宾照片", trigger: "blur" }
          { required: true, message: " ", trigger: "blur" }
            // {validator: coverByHandUrl, trigger: 'blur', required: true}
        ],
      },
      tabList: [],
      tabIndex: 0,
      templateList: [],
      posterlist: [], //海报
      imageList: [], //图文
      detailMsg:'',  //活动详情
      columnType:'',  //栏目type,
      delIdx:0,
      is_del:false,
      localLiveInfo:{}
    };
  },
  created() {
    
  },
  methods: {
    resetForm(){
  　　this.$nextTick(() => {
  　　　　this.$refs.guest.clearValidate()
  　　　　this.guestUpInfo = new FormData()
  　　})
    },
    //完成裁剪
    doCrop(icon, file){
    　　this.guestInfo.icon = icon
    　　this.guestUpInfo = file
    },
    //新增、编辑提交
    submitGuest(){
      validCallback(this, 'guest', () => {
        this.guestUpInfo.append('name',this.guestInfo.name)
        this.guestUpInfo.append('position',this.guestInfo.position)
        this.guestUpInfo.append('description',this.guestInfo.description)
        if(this.guestInfo.seq){
          this.guestUpInfo.append('seq',this.guestInfo.seq)
        }
        if(this.editGuest){
          this.guestUpInfo.append('id',this.guestInfo.id)
        }

        publicSubmitApi('saveSpeaker', this.guestUpInfo, true).then(res => {
          if (res.status === 200) {
            this.guestShow = false
            this.fetchData()
            this.$message({
              message: this.editGuest ? '编辑成功' : '新增成功',
              type: 'success'
            })
          }
        })
      })
    },
    makeNewImageText(){
      this.imagetextform.innerid=''
      this.msg=''      
    },
    addmakeNewImageText() {
      this.$router.push({name: 'VliveLiveSet', query: {id: this.$route.query.innerid, tab: 'SponsorInformation'}})
    },
    _getPosterList(reqdata) {
      this.setLoading(true)
      getPosterList({
        data: reqdata,
        success: data => {
          this.setLoading(false)
          if (data.code == "000") {
            // console.log("海报列表", data);
            if(data.data.content.length<10){
              this.loadingMore=false
            }
            // console.log()
            if(!this.is_del){
              this.currentpage++;
              // console.log('xinz')
            }
            var originData= this.posterlist;
            if(this.is_del){
              originData.splice(this.delIdx,1)
            }
            // console.log('originData',originData)
            let newArry=originData
            // console.log('currentpage:',reqdata.currentpage)
            if(reqdata.currentpage==1){
              newArry=data.data.content
            }
            else{
              newArry=originData.concat(data.data.content);
            }
            // console.log('newArray:',newArry)
            // originData.splice(0,1,data.data.content[0])
            const calc=(data)=>{
              let result = {};
              let finalResult = [];
              for (let i = 0; i < data.length; i++) {
                result[data[i].innerid] = data[i];
              }
              for (const item in result) {
                finalResult.push(result[item]);
              }
              return finalResult;
            }        
            this.posterlist =calc(newArry)
          } else {
            this.$message.error(data.msg)
          }
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
      // getPosterList(reqdata).then(data => {
        
      // });
    },
    _delPoster(data) {

      this.setLoading(true)
      delPoster({
        data: data,
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            // console.log("删除列表", data);
            this.delPosterStatus = false;
            this._getPosterList({
              columninnerid: this.columninnerid,
              currentpage: this.currentpage,
              pagesize: this.pagesize
            });
            this.$message({
              message: "删除海报成功",
              type: "success"
            });
          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })

      // delPoster(data).then(data => {
      //   if (data.code == "000") {
          
      //   }
      // });
    },
    _getPosterTeml(data) {

      this.setLoading(true)
      getPosterTeml({
        data: data,
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            this.templateList = data.data.content;
            let color = data.data.content[0] || {};
            this.timecolor = color.addresscolor;
            this.titlecolor = color.subjectcolor;
            this.namecolor = color.usernamecolor;
            this.companycolor = color.dutynamecolor;
            this.textcolor = color.ylcolor;
            this.unitcolor = color.companycolor;
            this.templateid=data.data.content[0].innerid;
            this.photoSize = data.data.content[0].imagewidth +"*"+data.data.content[0].imageheight
          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
      // getPosterTeml(data).then(data => {
      //   if (data.code == "000") {
          
      //   }
      // });
    },
    _doSavePoster(data) {

      this.setLoading(true)
      doSavePoster({
        data: data,
        success: data => {

          this.setLoading(false)
          this.posterLoading = false

          if (data.code == '000') {
            this.isLoadingSave=false;
            this.isLoadingSavePoster=false
            if (this.is_preview) {
              this.previewImageurl = `data:image/png;base64,${
                data.data.imagedata
              }`;
            } else {
              this._getPosterList({
                columninnerid: this.columninnerid,
                currentpage: 1,
                pagesize: this.pagesize
              });
            // this.$refs.form[0].resetFields();
              this.form.name='';
              this.form.company=''
              this.form.text=''
              this.form.name=''
              this.coverurl = null;
              this.logourl = null;
              this.form.cover=null
              this.$nextTick(()=>{
                document.getElementById('coverpic').src=null
                document.getElementById('logopic').src=null
                document.getElementById('guestfile').value=''
                document.getElementById('logofile').src=''
              })
              this.$message({
                message: "上传海报成功",
                type: "success"
              });
            }
          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
      // doSavePoster(data).then(data => {
      //   this.posterLoading=false
      //   if (data.code == "000") {
      //   }
      // });
    },
    _getDecorateList(data) {

      this.setLoading(true)
      getDecorateList({
        data: data,
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            
            console.log('getDecorateList', data)
            // console.log("list", data);
            this.tabList = data.data.content;
            this.columnType=data.data.content[0] && data.data.content[0].columntype
            this.livetitle=data.data.cwLivetvinfo[0].subject;
            this.livestatus=data.data.cwLivetvinfo[0].statusname;
            // this.form.time=data.data.cwLivetvinfo[0].timeplace;
            this.form.unit=data.data.cwLivetvinfo[0].livecompany
            this.form.time=data.data.cwLivetvinfo[0].timeplace
            this.dguserList = data.data.cwLivetvinfo[0].dgusername.split(',')
            this.form.title=data.data.cwLivetvinfo[0].subject;
            let id = data.data.content[0] && data.data.content[0].innerid;
            this.tabname =data.data.content[0] && data.data.content[0].innerid;
            this._getPicturetextList({
              liveinnerid: this.liveinnerid,
              columninnerid: id
            });
            this.columninnerid = id;
            setTimeout(()=>{
              //this.$refs.logopic.src=data.result.cwLivetvinfo[0];
            },300)
          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
      // getDecorateList(data).then(data => {
      //   if (data.code == "000") {
          
      //   }
      // });
    },
    _delPicturetextLive(data) {

      this.setLoading(true)
      delPicturetextLive({
        data: data,
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            this.delImageStatus = false;
            this._getPicturetextList({
              liveinnerid: this.liveinnerid,
              columninnerid: this.columninnerid
            });
          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })

      // delPicturetextLive(data).then(data => {
      //   if (data.code == "000") {
          
      //   }
      // });
    },
    _getPicturetextList(data) {

      this.setLoading(true)
      getPicturetextList({
        data: data,
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            // console.log("列表获取成功", data);
            if(this.columnType==1){
              this.imageList = data.data.content;
            }
            if(this.columnType==3){
              this.detailMsg=data.data.content.length?data.data.content[0].content:''
            }
          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })

      // getPicturetextList(data).then(data => {
      //   if (data.code == "000") {
          
      //   }
      // });
    },
    _saveImagetextinfo(data) {
      let that=this

      this.setLoading(true)
      saveImagetextinfo({
        data: data,
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            this.msg = "";
            //  this.$message({
            //   message: '发布直播成功',
            //   type: 'success'
            // });
            this._getPicturetextList({
              liveinnerid: this.liveinnerid,
              columninnerid: this.columninnerid
            });
            if(this.columnType==3){
              this.$message({
                message: "编辑信息成功",
                type: "success"
              });
            }
          } else {
            this.$message.error(daya.msg)
          }
          that.makeNewImageText();
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })

      // saveImagetextinfo(data).then(data => {
      //   if (data.code == "000") {
          
      //   }
      //   that.makeNewImageText();
      // });
    },    
    _getLiveInfo(data) {
      let that=this
      // console.log('_getLiveInfo', data)
      this.setLoading(true)
      getLiveInfo({
        data: data,
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
        
            that.localLiveInfo=data.data
            // console.log(that.localLiveInfo)
            that.form.unit=that.localLiveInfo.livecompany
            that.form.time=that.localLiveInfo.timeplace
            that.dguserList = data.data.dgusername.split(',')
            // console.log('data.data.dgusername', data.data.dgusername)
            that.hostposteratturl = data.data.hostposteratturl

            // this.$nextTick(() => {
            //   if (data.data.dgusername.length == 0) {
            //     that.dguserList = ['主持人']
            //   }
            //   console.log('that.dguserList',that.dguserList)
            //   if (that.dguserList.length > 0) {
            //     this.imagetextform.spokesman = that.dguserList[0]
            //   }
            // })

          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })

      // getLiveInfo(data).then(data => {
      //   if (data.code == "000") {
          
      //   }
      // });
    },
    tabpaneClick(){
    },
    save(type) {
      const { title, name, company, text, unit, time } = this.form;
      const {
        titlecolor,
        namecolor,
        companycolor,
        textcolor,
        unitcolor,
        timecolor
      } = this;

      let guestfile = this.$refs.guestfile[0].files[0]
      if(!guestfile){
        this.$message.error('嘉宾照片必传')
        return false
      }

      let formData = new FormData(); // FormData 对象
      formData.append("guestfile", this.$refs.guestfile[0].files[0])
      formData.append("logofile", this.$refs.logofile[0].files[0])
      formData.append("postersubject", title)
      formData.append("posterusername", name)
      formData.append("posterdutyname", company)
      formData.append("posteryl", text)
      formData.append("posteraddress", time)
      formData.append("postercompany", unit)
      // if(this.hostposteratturl){
      //   formData.append("hostposteratturl", this.hostposteratturl)
      // }

      formData.append("subjectcolor", titlecolor.substring(1))
      formData.append("usernamecolor", namecolor.substring(1))
      formData.append("dutynamecolor", companycolor.substring(1))
      formData.append("ylcolor", textcolor.substring(1))
      formData.append("companycolor", unitcolor.substring(1))
      formData.append("addresscolor", timecolor.substring(1))

      formData.append("innerid", this.liveinnerid)
      formData.append("templateid", this.templateid)
      formData.append("columninnerid", this.columninnerid)
     
      if(this.templateid){
        this.form.template='null'
      }else{
         this.form.template=''
      }

      // console.log('111',document.getElementById('coverpic').getAttribute('src'))
      if( document.getElementById('coverpic').getAttribute('src')=='cover' ||  document.getElementById('coverpic').getAttribute('src')=='null'){
          // console.log(123454)
          this.form.cover=''
      }else{
        // console.log(235445466)
          this.form.cover='cover'
      }
      if (type) {
        formData.append("ispreview", 1);
        this.is_preview = true;
      } else {
        formData.append("ispreview", 0);
        this.is_preview = false;
      }
      this.$refs.form[0].validate(valid => {
          if (valid) {
           this._doSavePoster(formData);
            if(type){
              this.isLoadingSave=true;
              this.dialogPreviewVisible = true;
            }else{
              this.isLoadingSavePoster=true
            }
          } else {
            // console.log("error submit!!");
            return false;
          }
        });
    },
    //手动上传海报
    saveByHand(){
      let formData = new FormData(); // FormData 对象
      let handFile = this.$refs.guestHandfile[0].files[0]
      if(!handFile){
        this.$message.error('嘉宾照片必传')
        return false
      }
      // this.$message({
      //   type:'warning',
      //   message:'上传尺寸938*1672效果最佳',
      //   duration:0
      // })
      formData.append("guestfile", handFile);
      formData.append("innerid", this.liveinnerid);
      formData.append("columninnerid", this.columninnerid);
      this.isLoadingSavePoster=true;

      this.setLoading(true)
      doSavePosterByHand({
        data: formData,
        success: data => {
          this.setLoading(false)

          this.isLoadingSavePoster=false;

          if (data.code == '000') {
            this._getPosterList({
              columninnerid: this.columninnerid,
              currentpage: 1,
              pagesize: this.pagesize
            });
            this.coverByHand=''
            document.getElementById('coverHandpic').src=null
            document.getElementById('guestHandfile').value=''
            this.$message({
              message: "上传海报成功",
              type: "success"
            });
          } else {
            this.$message.error(daya.msg)
          }
        },
        errro: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })

      // doSavePosterByHand(formData).then(res=>{
      //   this.isLoadingSavePoster=false;
      //   if(res.code =='000'){
          
      //   }
      // });
    },
    previewClick() {
      this.dialogPreviewVisible = false;
    },
    //提交数据
    release(type) {
      // console.log(this.msg);
      let params = {
        innerid:this.imagetextform.innerid,
        liveinnerid: this.liveinnerid,
        columninnerid: this.columninnerid,
      };
      let content=this.msg
      if(type==1 && this.imagetextform.innerid==''){
        //新增才进行发言人组装
        if(this.imagetextform.spokesman!=''){
          content='<p><span style="color: '+this.imagetextform.spokesmancolor+';"><strong>'+this.imagetextform.spokesman+'：</strong></span></p>'+content
        }
      }      
      if(type==1){
        this._saveImagetextinfo(Object.assign({},params,{content: content}));
      }else if(type==3){
        this._saveImagetextinfo(Object.assign({},params,{content: this.detailMsg}));
      }
    },
    //编辑图文直播
    editImageText(innerid) {
      this.imagetextform.innerid=innerid
      this.imagetextform.spokesman=''
      let content=''
      for(var i=0;i<this.imageList.length;i++){
        if(this.imageList[i].innerid==innerid){
          content=this.imageList[i].content
          break;
        }
      }
      this.msg=content
    },
    delClick(innerid) {
      this.delImageStatus = true;
      this.dialogImageParams = innerid;
    },
    delImageSuccess(innerid) {
      this._delPicturetextLive({ innerid });
    },
    tabClick(tab, event) {
      //console.log('tab',this.tabname)
      let data=this.tabList.filter(item=>{return item.innerid==this.tabname})[0];
      if(data.columntype==11 || data.columntype==12){
        window.open(data.columnurl,'_blank')
      }
      // console.log('data',data)
      const columninnerid = data.innerid;
      this.columninnerid=columninnerid; 
      this.columnType=data.columntype //栏目type 
      if(data.columntype==1 || data.columntype==3){
         this._getPicturetextList({
          liveinnerid: this.liveinnerid,
          columninnerid: columninnerid
        });
      }
      if(data.columntype==2 ){
          this._getPosterList({
          columninnerid: columninnerid,
          currentpage: this.currentpage,
          pagesize: this.pagesize
        });
      }
    },
    //复制海报文字信息
    copyPostText(innerid,idx) {
      for(var i=0;i<this.posterlist.length;i++){
        if(this.posterlist[i].innerid==innerid){
          this.form.name=this.posterlist[i].posterusername
          this.form.company=this.posterlist[i].posterdutyname
          this.form.text=this.posterlist[i].posteryl
          break;
        }
      }
    },
    delPostClick(innerid,idx) {
      this.dialogParams = innerid;
      this.delPosterStatus = true;
      this.delIdx=idx;
      this.is_del=true
    },
    delPosterSuccess(innerid) {
      this._delPoster({ innerid });
    },
    previewImage(picId, fileId) {
      var pic = document.getElementById(picId);
      var file = document.getElementById(fileId);
      var fileSize = 0;
      var fileMaxSize = 2048*2; //500k  2048 1M
      var filePath = file.value;
      if (filePath) {
        fileSize = file.files[0].size;
        var size = fileSize / 1024;
        if (size > fileMaxSize) {
          this.$message.error("图片大小不能超过 2M!");
          file.value = "";
          return false;
        } else if (size <= 0) {
          //ShowPopAlert("文件大小不能为0M！", 2);
          file.value = "";
          return false;
        }
      } else {
        return false;
      }
      if (window.FileReader) {
        let oFReader = new FileReader();
        oFReader.readAsDataURL(file.files[0]);
        oFReader.onload = function(oFREvent) {
          pic.src = oFREvent.target.result;
        };
      }
    },
    templateClick(data) {
      this.templateid = data.innerid;
      this.titlecolor=data.subjectcolor;
      this.namecolor=data.usernamecolor;
      this.companycolor=data.dutynamecolor;
      this.textcolor=data.ylcolor;
      this.unitcolor=data.companycolor;
      this.timecolor=data.addresscolor;
      this.photoSize = data.imagewidth +"*"+data.imageheight
    },
    scroll(){
      window.onscroll =()=>{
         var isLoadingMore = this.loadingMore;
        let bottomOfWindow = document.documentElement.offsetHeight - document.documentElement.scrollTop - window.innerHeight <= 100
        if (bottomOfWindow && isLoadingMore) {
          this._getPosterList({
            columninnerid: this.columninnerid,
            currentpage: this.currentpage,
            pagesize: this.pagesize
          })
        }
        if(isLoadingMore){
           this._getPosterList({
            columninnerid: this.columninnerid,
            currentpage: this.currentpage+1,
            pagesize: this.pagesize
          })
        }
      }
     
    },
    ...mapActions(['setLoading'])
  },
  mounted(){
    this.scroll()
  },
  created() {
    let liveinnerid = getQueryParams().innerid;
    this.liveinnerid = liveinnerid;
    this._getPosterTeml();
    this._getDecorateList({ liveinnerid: liveinnerid });
    this._getLiveInfo({ innerid: liveinnerid });
  }
};
</script>

<style lang='scss'>

.Liveing {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #F5F7FA;
  height: 100%;
  // overflow-x: auto;

  .el-tabs {
    margin: 0 12px;
    background: #fff;
    height: calc(100% - 74px);
    .el-tabs__header {
      padding: 0 20px; 
    }
    .el-tabs__header,
    .el-tabs--card>.el-tabs__header {
      margin: 0 !important;
    }
    .el-tabs__content {
      height: calc(100% - 40px);
      overflow: auto;
    }
  }


  #imagetextform {
    .el-select {
      float: left;
      margin-right: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
  }


  .imageTextliveing {
        .edui-editor.edui-default {
          margin-top: 20px;
          height: 660px;
        }

        iframe {
          height: 543px;
        }
  } 
  

  .detailsactive {
        .edui-editor.edui-default {
          margin-top: 20px;
          height: 702px;
        }

        iframe {
          height: 585px;
        }
  } 

  // @media (max-width: 1500px){
  //   .imageTextliveing {
  //         .edui-editor.edui-default {
  //           height: 500px;
  //         }
  //         iframe {
  //           height: 403px;
  //         }
  //   }

  //   .detailsactive {
  //       .edui-editor.edui-default {
  //         height: 500px;
  //       }

  //       iframe {
  //         height: 403px;
  //       }
  // } 
  // }


  .tab-title {
    height: 50px;
    color: #333333;
    border-bottom: 1px solid rgba(228, 231, 237, 1);
    border-radius: 3px;
    margin-bottom: 14px;
    padding-left: 10px;
    span {
      padding: 0px 10px;
      display: inline-block;
      border: 1px solid #e5e5e5;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
      margin-top: 10px;
      border-right: 0px;
      border-bottom: 0px;
      font-size: 12px;
    }
    span:nth-child(1) {
      border-top-left-radius: 4px;
    }
    span:last-child {
      border-right: 1px solid #e5e5e5;
      border-top-right-radius: 4px;
    }
    .isActive {
      color: #0084ff;
    }
  }
  .imageText {
    // .activity-detail{
    //   position: fixed;
    //   top: 110px;
    //   left: 20px;
    // }
    background: #fff;

    .ueditor {
      float: left;
      margin: 12px 40px 0 20px;
      padding-right: 10px;
      width: 600px;
      // height: 700px;
      // overflow: hidden;

      .release-icon {
        text-align: center;
        position: fixed;
        z-index: 999;
        left: 200px;
        bottom: 30px;
        .send-btn{
          width: 200px;
        }
        .el-button {
          display: block; 
          margin: auto;
          margin-left: 40px;
          width: 160px;
        }
      }
      .edui-default .edui-editor-bottomContainer {
        overflow: hidden;
        display: none;
      }
    }
    .image-list {
      width: calc(100% - 680px );
      max-width: 800px;
      // flex: 1;
      background: #f2f2f2;
      align-items: center;
      // display: flex;
      // flex-direction: column;
      padding-top: 10px;
      height: 813px;
      overflow-y: scroll;
      overflow-x: hidden;
      .image-item {
        //width: 620px;
        background: #fff;
        margin-bottom: 20px;
        border-radius: 4px;
        position: relative;
        padding: 1px 65px;
        margin: 20px;
        .top-set-span{
          height: 25px;
          font-size: 13px;
        }
        img{
          width: 100% !important;
          // width: auto;
          // max-width: 100%;
        }
        
        .edit-icon {
          position: absolute;
          color: #0084FF;
          right: 80px;
          top: 10px;
          cursor: pointer;
          label {
            background: url("../../../../common/images/liveing/media_editor.png") no-repeat;
            background-size: contain;
            margin-right: 4px;
            width: 14px;
            height: 14px;
            display: inline-block;
            vertical-align: text-top;
          }
        }
        .del-icon {
          position: absolute;
          color: #ff676a;
          right: 10px;
          top: 10px;
          cursor: pointer;
          label {
            background: url("../../../../common/images/liveing/set_dele.png") no-repeat;
            margin-right: 4px;
            width: 16px;
            height: 16px;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .time-icon {
          background: url("../../../../common/images/liveing/feed_tab_icon.png") no-repeat;
          position: absolute;
          left: -10px;
          top: 0px;
          width: 83px;
          height: 42px;
          background-size: 83px 42px;
          display: inline-block;
          font-size: 12px;
          color: #fff;
          line-height: 32px;
          text-align: center;
        }
        p {
          margin: 16px 0;
          word-break: break-all;
          line-height: 1.25;
        }
      }
      &::-webkit-scrollbar {
        width: 6px;
        /*height: 4px;*/
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px #0084ff;
        background: rgba(0, 0, 0, 0.2);
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }
  .post-wrap {
    // display: flex;
    .el-tabs__header {
      display: none;
      height: 90vh;
    }
    .el-radio-group {
      height: 30px;
      .el-radio-button, .el-radio-button__inner {
        height: 30px;
      }
      .el-radio-button__inner {
        padding: 8px 20px;
      }
    }
    .poster-form {
      // flex: 1;
      margin-right: 10px;
      padding-left: 7px;
      width: 640px;
      float: left;
      .inp-two-first{
        margin-left: 13px;
        width: 190px;
      }
      .el-upload__tip {
        float: left;
        width: auto;
        font-size: 12px;
        color: #909399;
        margin-top: 37px;
        margin-left: 23px;
        line-height: 18px;
      }
      .footer-btn {
        text-align: center;
        margin-bottom: 20px;
        margin-top: 25px;
        .el-button {
          width: 150px;
          height: 35px;
          padding: 0px;
          line-height: 35px;
        }
      }
      .cover-setting {
        display: flex;
        &.qrcode {
          .image {
            width: 100px;
            height: 100px;

            img::after {
              content: "+";
              display: block;
              width: 100px;
              height: 100px;
              font-size: 45px;
              color: #909399;
              text-align: center;
              line-height: 100px;
            }
          }
        }
        .image {
          float: left;
          position: relative;
          width: 189px;
          height: 106px;
          background: #F5F7FA;
          border-radius:4px;
          box-sizing: border-box;
          border: solid 1px transparent;
          
          img {
            width: 100%;
            height: 100%;
            border-radius:4px;

            &::after {
              content: "+";
              display: block;
              width: 189px;
              height: 106px;
              font-size: 45px;
              color: #909399;
              text-align: center;
              line-height: 100px;
            }
          }
        }
            
        .up-load {
          // margin-left: 16px;
          position: relative;

          .uploadBtn {
            position: absolute;
            z-index: 10;
            width: 189px;
            height: 106px;
            top: 0;
            left: 0;
            opacity: 0;
            cursor: pointer;
            &.qrcodeinput {
              width: 100px;
              height: 100px;
            }
            &:hover + .image {
              box-sizing: border-box;
              border: solid 1px #409eff;
            }
          }
          
          .el-button {
            width: 100px;
            height: 30px;
            background: #fff;
            color: #0084ff;
            margin-top: 30px;
            cursor: pointer;
          }
        }
      }
      .aa {
        .image-template {
          // display: flex;
          img {
            width: 48px;
            height: 80px;
            margin-right: 14px;
            cursor: pointer;
          }
          .active {
            border: 2px solid #0084ff;
          }
        }
      }
      .el-form-item {
        margin-bottom: 1px;
        display: flex;
      }
      .el-form-item__label {
        text-align: left;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 32px;
        // padding: 0 10px 0 10px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 110px;
      }
      .el-form-item.is-required .el-form-item__label::before {
          display: none;
      }
      .el-form-item.is-required .el-form-item__label::after {
          content: '*';
          color: #F56C6C;
          margin-left: 4px;
      }

      .el-input__inner {
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 28px;
        line-height: 28px;
        outline: 0;
        padding: 0 10px;
        -webkit-transition: border-color 0.2s
          cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
      }
      .el-form-item__content {
        line-height: 30px;
        position: relative;
        font-size: 14px;
        display: inline-block;
        display: inherit;
        width: 100%;
        margin-left: 0px;
      }
      el-input {
        position: relative;
        font-size: 14px;
        display: inline-block;
        width: 300px;
      }
      .el-form-item__error {
            padding-top: 0px !important;
        }
      .el-form-item.is-error .el-input__inner{
          border-color: #f56c6c;
      }
      .text-color-wrap {
        width: 200px;
        height: 30px;
      }
      .text-color {
        vertical-align: text-bottom;
        margin: 0px 10px;
        border: 1px solid rgba(220, 227, 238, 1);
        border-radius: 3px;
        //padding: 7px 10px;
        display: inline-block;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
      }
      .el-color-picker__trigger {
        display: inline-block;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 32px;
        width: 40px;
        padding: 4px;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        font-size: 0;
        position: relative;
        cursor: pointer;
      }
    }
    .poster-list {
      width: calc(100% - 670px);
      max-width: 800px;
      // height: 600px;
      height: 87.9vh;
      overflow-y: auto;
      background: rgba(242, 242, 242, 1);
      margin-left: 12px;
      border-radius: 4px;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 20px 0 20px 69px;
      span {
        width: 180px;
        height: 320px;
        display: inline-block;
        margin-bottom: 40px;
        margin-right: 8%;
       // border: 1px solid red;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .copytext,
        .delposter {
          position: absolute;
          margin-top: 10px;
          color: #F56C6C;
          display: block;
          font-size: 14px;
          cursor: pointer;
        }
        .copytext {
          left: 20px;
        }
        .delposter {
          right: 20px;
        }
      }
      &::-webkit-scrollbar {
          width: 6px;    
          /*height: 4px;*/
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px #0084ff;
            background: rgba(0,0,0,0.2);
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);
        
        }
    }
  }
  .preview-dialog {
    height: 570px;
    top: 0;
    .el-dialog__header {
      height: 45px;
      background: linear-gradient(
        90deg,
        rgba(76, 184, 255, 1) 0%,
        rgba(84, 144, 255, 1) 100%
      );
      padding: 0px;
      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #fff;
        line-height: 50px;
        padding-left: 20px;
      }
      .el-dialog__headerbtn {
        position: absolute;
        top: 16px;
        right: 20px;
        padding: 0;
        background: 0 0;
        border: none;
        outline: 0;
        cursor: pointer;
        font-size: 16px;
        .el-dialog__close {
          color: #fff;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px 20px;
      font-size: 14px;
      color: #0084ff;
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
      .el-button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        font-weight: 500;
        font-size: 14px;
        border-radius: 4px;
        width: 90px;
        height: 30px;
        line-height: 30px;
        padding: 0px;
      }
      .el-button:nth-child(1) {
       // margin-right: 38px;
        //background: #e5e5e5;
        color: #fff;
      }
      .el-button:nth-child(2) {
        background: #0084ff;
        color: #fff;
      }
    }
  }
}
.edit-hb-row-mb{
  margin-bottom: 12px;
}
@media screen and (max-width: 1366px) {
  .edit-hb-row-mb{
    margin-bottom: 12px;
  }
}
@media screen and (min-width:1367px) and (max-width: 1440px) {
  .edit-hb-row-mb{
    margin-bottom: 12px;
  }
}
@media screen and (min-width:1441px) and (max-width: 1680px) {
  .edit-hb-row-mb{
    margin-bottom: 12px;
  }
}
@media screen and (min-width:1681px) and (max-width: 1920px) {
  .edit-hb-row-mb{
    margin-bottom: 12px;
  }
}

</style>